import { render, staticRenderFns } from "./ChatToolbar.vue?vue&type=template&id=3d252572&scoped=true&"
import script from "./ChatToolbar.vue?vue&type=script&lang=js&"
export * from "./ChatToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ChatToolbar.vue?vue&type=style&index=0&id=3d252572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d252572",
  null
  
)

export default component.exports